// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2T-1m","buttons":"RemoveExpirationActionButtons_buttons__1Xrox"};